import { AudioCaptureWaveForm } from "@/components/layout/components/AudioCaptureWaveForm";
import { MdsIconKind } from "@/design-system/components/icon";
import { getIconKind } from "@/design-system/components/item-list/rows/icon/icon-kind";
import { MDSIconButton, MDSIconButtonVariant } from "@/mds";
import styled from "@emotion/styled";

interface Props {
  isSelected?: boolean;
  isHighlighted?: boolean;
  toggleSelected?: (event: React.MouseEvent) => void;
  isActiveAudioCapture?: boolean;
  className?: string;
}

export function NoteIcon({
  isSelected,
  isHighlighted,
  toggleSelected,
  isActiveAudioCapture,
  className,
}: Props) {
  return (
    <StyledIconButton
      className={className}
      onClick={toggleSelected}
      variant={MDSIconButtonVariant.Transparent}
      $isSelected={isSelected}
      iconKind={getIconKind({
        isSelected,
        isHighlighted,
        defaultIcon: isActiveAudioCapture ? () => <AudioCaptureWaveForm /> : MdsIconKind.Document,
      })}
    />
  );
}

const StyledIconButton = styled(MDSIconButton)<{ $isSelected?: boolean }>`
  padding: 0px;
  height: 16px;
  width: 16px;

  .mds-icon {
    font-size: 18px;
    height: 18px;
    width: 18px;
    color: ${({ $isSelected, theme }) =>
      $isSelected ? theme.colors.mblue.x500 : theme.colors.icon.placeholder};
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
`;

export const SmallNoteIcon = styled(NoteIcon)`
  height: 16px;
  width: 16px;

  .mds-icon {
    font-size: ${({ theme }) => theme.fontSizes.xxxsmall};
    height: 11px;
    width: 11px;
  }
`;
